import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M7.049 18.024c2.506 2.723 5.51 3.666 5.51 3.666s7.467-2.467 7.553-9.7c0 0 .034-6.75-.482-6.982-.557-.267-4.308.634-8.196-2.573-3.494 3.593-7.087 3.077-7.574 3.4 0 0-.418 4.194 1.129 7.192"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M10 11.31 12.941 14 19.5 2"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
  </svg>
);
export const ShieldIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
